<script setup lang="ts">
const runtimeConfig = useRuntimeConfig()
const widgetId = String(runtimeConfig.public.SENJA_WIDGET_ID)
const hasError = ref(false)

function loadSenja(): void {
  if (document.querySelector(`script[data-senja-widget="${widgetId}"]`)) {
    return
  }

  const script = document.createElement('script')
  script.src = `https://widget.senja.io/widget/${widgetId}/platform.js`
  script.type = 'text/javascript'
  script.async = true
  script.dataset.senjaWidget = widgetId
  script.addEventListener('error', () => {
    hasError.value = true
  })
  document.head.appendChild(script)
}

onMounted(loadSenja)
</script>

<template>
  <div class="min-h-[180px]">
    <div
      v-if="!hasError"
      class="senja-embed"
      :data-id="widgetId"
      data-mode="shadow"
      data-lazyload="false"
      style="display: block; width: 100%;"
    />
    <div v-else class="rounded-2xl border border-slate-200 bg-white p-6 text-center text-sm text-slate-600">
      Les avis ne peuvent pas être chargés pour le moment. Votre bloqueur de contenu peut empêcher l’affichage du widget Senja.
    </div>
  </div>
</template>
